<template>
	<fieldset :disabled="loading > 0">
		<b-form-row>
			<b-col cols="12" sm="6" md="8">
				<form @submit.prevent.stop="saveField('goal', parseInt(goal||0)||0, 'Goal')" class="mb-3">
					<b-input-group prepend="Goal" class="mt-1" size="sm">
						<b-form-input type="number" v-model.number="goal" min="0"></b-form-input>
						<b-input-group-append>
							<b-input-group-text>subs</b-input-group-text>
							<b-button type="submit" variant="primary">Set</b-button>
						</b-input-group-append>
					</b-input-group>
				</form>
			</b-col>
			<b-col>
				<b-icon v-show="saving > 0" icon="circle-fill" animation="throb" class="mt-2"></b-icon>
			</b-col>
			<b-col cols="12" sm="6" md="8">
				<form @submit.prevent.stop="saveField('count', parseInt(count||0)||0, 'Count')" class="mb-3">
					<b-input-group prepend="Count" class="mt-1" size="sm">
						<b-form-input type="number" no-wheel v-model.number="count" min="0"></b-form-input>
						<b-input-group-append>
							<b-input-group-text>subs</b-input-group-text>
							<b-button type="submit" variant="primary">Set</b-button>
						</b-input-group-append>
					</b-input-group>
				</form>
			</b-col>
			<b-col cols="12" sm="6" md="4">
				<form @submit.prevent.stop="addCount" class="mb-3">
					<b-input-group class="mt-1" size="sm">
						<b-form-input type="number" v-model.number="countAdd"></b-form-input>
						<b-input-group-append>
							<b-input-group-text>subs</b-input-group-text>
							<b-button type="submit" variant="secondary" :disabled="!countAdd">Add</b-button>
						</b-input-group-append>
					</b-input-group>
				</form>
			</b-col>
		</b-form-row>
	</fieldset>
</template>

<script>
export default {
	data() { return {
		loading: 0,
		saving: 0,
		count: 0,
		countAdd: '',
		goal: 0,
		subId: null,
	}; },
	watch: {
		loading(val) { this.$emit('loading', val > 0); },
	},
	mounted() {
		this.loadData();
	},
	beforeDestroy() {
		this.subId && this.$socket.unsubscribe(this.subId);
	},
	methods: {
		async loadData() {
			this.loading++;
			try {
				const [user, settings] = await Promise.all([
					this.$api.get('userData'),
					this.$api.get('widgetSettings/sub-goal'),
				]);
				this.count = settings?.count || 0;
				this.goal  = settings?.goal  || 0;

				this.subId = this.$socket.subscribe(user?.widget_hash, {
					widgetSettingsFieldChange: msg => {
						if(msg.widgetType !== 'sub-goal') return;
						if(msg.field === 'count') this.count = msg.value;
						if(msg.field === 'goal')  this.goal  = msg.value;
					},
				});
			} catch(e) {
				if(e.message === 'Subscription required') return;
				this.$bvToast.toast(`Could not load sub goal settings: ${e.error||e.toString()}`, { title: 'Error', variant: 'danger', solid: true });
			} finally {
				this.loading--;
			}
		},
		async saveField(field, value, name, add) {
			this.saving++;
			try {
				await this.$api.post(`widgetSettings/sub-goal/${encodeURIComponent(field)}`, { value, add });
				if(add) this.reloadCount();
			} catch(err) {
				this.$bvToast.toast(`Could not update ${name}: ${err.error||err.toString()}`, { title: 'Error', variant: 'danger', solid: true });
			} finally {
				this.saving--;
			}
		},
		async reloadCount() {
			try {
				const settings = await this.$api.get('widgetSettings/sub-goal');
				this.count = settings?.count || 0;
			} catch(e) { /* ignore */ }
		},
		addCount() {
			this.saveField('count', parseInt(this.countAdd||0)||0, 'Count', true);
			this.countAdd = '';
		},
	},
};
</script>
